import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const TagsList = styled.div<{ desktopGap: string; mobileGap: string }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ mobileGap }) => mobileGap};

  ${QUERIES.tabletAndUp} {
    gap: ${({ desktopGap }) => desktopGap};
  }
`;
